/**
 * The person kind's guard — `EntrySlice.guard`, once the registry (#312) binds it.
 */

import type { Entry } from '@/document'
import type { PersonEntry } from './meta'

export function isPersonEntry(entry: Entry): entry is PersonEntry {
  return entry.type === 'person'
}
